import { useGet } from '../../HttpClient';
import { CalendarModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useGlobalContext } from '../../../GlobalContextProvider';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useCalendars({ calendarType }: { calendarType: string }) {
  const get = useGet(true, pillarCode);
  const getCalendars = (calendarType: string): Promise<CalendarModel[]> =>
    get(`${referenceDataBaseUrl}/calendar-types/${calendarType}/calendars`);
  const { tenantId } = useGlobalContext();
  return useQueryWithErrorHandling({
    queryKey: ['get-calendars', calendarType, tenantId],
    queryFn: async () => await getCalendars(calendarType),
    enabled: !!calendarType,
  });
}

export function useRefreshCalendars() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-calendars'] });
}
